module.exports = __webpack_public_path__ + "static/media/YAB3.33407ef2.jpg";